<template>
  <svg v-bind="$attrs" class="fill-current" :class="width" viewBox="0 0 32 32">
    <use :xlink:href="xlink" />
  </svg>
</template>

<script>
import { computed } from 'vue';

export default {
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 6
    },
    type: String,
  },
  setup(props) {
    const width = computed(() => ({
      2: 'w-2 h-2',
      3: 'w-3 h-3',
      4: 'w-4 h-4',
      5: 'w-5 h-5',
      6: 'w-6 h-6',
      8: 'w-8 h-8',
      10: 'w-10 h-10',
    }[props.size]));

    const xlink = computed(() => `#icon-${props.type}`);

    return {
      width,
      xlink,
    }
  }
}
</script>
